export type SettingsReducerState = {
  activeTab: SettingsTabs;
};

export enum SettingsTabs {
  Profile = 'PROFILE',
  Subscriptions = 'SUBSCRIPTIONS',
  General = 'GENERAL',
}

export enum SettingsIds {
  AccountTest1 = 'test1',
  AccountTest2 = 'test2',
}

export type SettingItem = {
  id: SettingsIds;
  title: string;
};

export const AccountSettings: SettingItem[] = [
  { id: SettingsIds.AccountTest1, title: 'אפשרות 1' },
  { id: SettingsIds.AccountTest2, title: 'אפשרות 2' },
];

export const Settings: Record<string, SettingItem[]> = {
  account: AccountSettings,
};

export type SettingStateType = string | boolean | number;

interface BaseSettingsState {
  id: SettingsIds;
  value: SettingStateType;
}

interface BooleanSettingsState extends BaseSettingsState {
  id: SettingsIds.AccountTest1 | SettingsIds.AccountTest2;
  value: boolean;
}
